import { lazy } from "react";

// After a new deploy, old JS chunk files are removed from the server. A browser
// tab that was already open still references the old chunk hashes, so clicking
// a sidebar link that lazy-loads a not-yet-fetched page fails silently and the
// previous page stays on screen until the user manually refreshes. Detect that
// failure and force a single automatic reload so the fresh app is fetched.
export default function lazyWithReload(importFn) {
  return lazy(async () => {
    try {
      return await importFn();
    } catch (error: any) {
      const reloadKey = "ae-chunk-reload-attempted";
      const alreadyAttempted = window.sessionStorage.getItem(reloadKey);
      if (!alreadyAttempted) {
        window.sessionStorage.setItem(reloadKey, "true");
        window.location.reload();
        // Return a never-resolving promise while the reload takes effect.
        return new Promise(() => {});
      }
      throw error;
    }
  });
}
